<ng-container *transloco="let t">
  <app-small-header [loading]="loading$ | async"></app-small-header>

  @if ((loading$ | async) === false && user()?.admin) {
    <div
      class="flex align-center w-p100 card-wrapper justify-center gap-2xl"
      >
      <cw-card class="card-content"
        type="vertical"
        size="medium"
        [cardTitle]="t('userRoles.administrationRole')"
        [clickable]="true"
        [showSelect]="false"
        [checked]="false"
        [selected]="false"
        [routerLink]="ROUTES.ADMINISTRATION"
        >
        <div slot="image">
          <cw-icon size="lg" icon="folder"></cw-icon>
        </div>
      </cw-card>
      <cw-card class="card-content"
        type="vertical"
        size="medium"
        [cardTitle]="t('userRoles.userRole')"
        [clickable]="true"
        [showSelect]="false"
        [checked]="false"
        [selected]="false"
        [routerLink]="ROUTES.COMBINATIONS"
        >
        <div slot="image">
          <cw-icon size="lg" icon="note"></cw-icon>
        </div>
      </cw-card>
    </div>
  }
</ng-container>
